// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__1Neu5","skBouncedelay":"Spinner_skBouncedelay__1GHyU","bounce1":"Spinner_bounce1__13hxm","bounce2":"Spinner_bounce2__1cFIk"};